import { generic } from "@/repositories/generic";
import { AppInfo } from "@/types/v2/App";

export const appInfoRepository = {
  get: () => {
    return generic.get<AppInfo>("appInfo", "config");
  },
  set: (appInfo: AppInfo) => {
    return generic.create({ ...appInfo, id: "appInfo" }, "config/appInfo");
  },
  update: async (appInfo: AppInfo) => {
    try {
      return await generic.update(
        { ...appInfo, id: "appInfo" },
        "config/appInfo"
      );
    } catch (e) {
      console.log(e);
      return await generic.create(
        { ...appInfo, id: "appInfo" },
        "config/appInfo"
      );
    }
  },
  subscribe: (callback: (doc: AppInfo | undefined) => void) => {
    return generic.subscribeDocument<AppInfo>("appInfo", "config", callback);
  },
};
